import React from "react"
import { CookieConsentsProvider } from "./src/hooks/cookie-consents-provider"
export const wrapRootElement = ({ element }) => (
  <CookieConsentsProvider cookieName="cookieConsents" expiryInDays={365}>
    {element}
  </CookieConsentsProvider>
)
